import { render, staticRenderFns } from "./LogoComponent.vue?vue&type=template&id=85732412"
import script from "./LogoComponent.vue?vue&type=script&lang=js"
export * from "./LogoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports